export const initSplineAnimation = () => {
  const introElement = document.querySelector('#intro .js-animation-wrapper');

  if (!introElement) {
    console.warn('Element with id="intro" not found. Spline animation will not be initialized.');
    return;
  }

  const canvas = document.createElement('canvas');
  canvas.classList.add('intro-animation');
  introElement.appendChild(canvas);

  const resizeCanvas = () => {
    const ctx = canvas.getContext('webgl2');
    canvas.style.width = '1000px';
    canvas.style.height = '1000px';
    ctx.viewport(0, 0, canvas.width, canvas.height);
  };

  const observer = new IntersectionObserver(async ([entry]) => {
    if (!entry.isIntersecting) return;

    observer.disconnect();

    try {
      const { Application } = await import('@splinetool/runtime');
      const splineApp = new Application(canvas);

      await splineApp.load('/images/home-animation/scene.splinecode');

      console.log('Spline animation initialized using canvas + runtime.');
      resizeCanvas();
      setTimeout(() => canvas.classList.add('intro-animation--visible'), 500);

      document.addEventListener('visibilitychange', () => {
        document.hidden ? splineApp.stop() : splineApp.play();
      });

      new IntersectionObserver(
        ([e]) => (e.isIntersecting ? splineApp.play() : splineApp.stop()),
        { threshold: 0 },
      ).observe(introElement);
    } catch (err) {
      console.error('Failed to load Spline scene:', err);
    }
  }, { threshold: 0 });

  observer.observe(introElement);
};
